const state = {
  selectedCities: [],
};


const mutations = {
  REMOVE_CITY(localState, city) {
    localState.selectedCities = localState.selectedCities.filter(e => e.id !== city.id);
  },
  ADD_CITY(localState, city) {
    if (localState.selectedCities[0].id == '') {
      localState.selectedCities = [];
    }
    localState.selectedCities.push(city);
  },
  REMOVE_ALL_FILTERS(localState) {
    localState.selectedCities = [{ id: '', name: 'Все города' }];
  },
  ADD_DEFAULT_CITY(localState, city) {
    localState.selectedCities = [];
    localState.selectedCities.push(city);
  },
  SET_DEFAULT_CITY(localState, city) {
    localState.selectedCities = [];
    localState.selectedCities.push(city);
  },
};


const actions = {
  removeCityFromFilter({ commit }, city) {
    commit('REMOVE_CITY', city);
  },
  addCitytoFilter({ commit }, city) {
    commit('ADD_CITY', city);
  },
  removeAllFilters({ commit }) {
    commit('REMOVE_ALL_FILTERS');
  },
  addDefaultCitytoFilter({ commit }, city) {
    commit('ADD_DEFAULT_CITY', city);
  },
  setDefault({ commit }, city) {
    commit('SET_DEFAULT_CITY', city);
  },
};


export default {
  mutations,
  actions,
  state,

};
